import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('usercentrics-script-loader', () => import(/* webpackMode: "lazy" */'./usercentrics-script-loader'));
